import React, { useState } from "react";
import { Header, Footer } from "./Layout";
import LandingPage from "./Pages/LandingPage";
import Output from "./Pages/Output";
import AppContext from "../context";
import themes from "../themes";
import T2TCanvas from "./canvas/useCanvas";
import useError from "./Form/useError";
import background1 from "../images/grid-bg.png";
import "../MathGenerator.scss";

function App() {
  const { error, errorRef, setError } = useError(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [uuid, setUuid] = useState("");
  const [saved, setSaved] = useState(false);
  let canvas = new T2TCanvas();
  const [myCanvas, setCanvas] = useState(canvas);
  const [currentPage, setCurrentPage] = useState("pledges");
  const [selectedQuote, setSelectedQuote] = useState(themes.pledges.alt1);
  const [metaRedImage, setMetaRedImage] = useState();
  const [metaNavyImage, setMetaNavyImage] = useState();
  const [metaTealImage, setMetaTealImage] = useState();
  const [instaRedImage, setInstaRedImage] = useState();
  const [instaNavyImage, setInstaNavyImage] = useState();
  const [instaTealImage, setInstaTealImage] = useState();

  return (
    <AppContext.Provider
      value={{
        name,
        email,
        themes,
        saved,
        myCanvas,
        currentPage,
        uuid,
        selectedQuote,
        metaNavyImage,
        metaRedImage,
        metaTealImage,
        instaNavyImage,
        instaTealImage,
        instaRedImage,
        setError,
        setName,
        setEmail,
        setSaved,
        setCurrentPage,
        setUuid,
        setSelectedQuote,
        setInstaNavyImage,
        setInstaRedImage,
        setInstaTealImage,
        setMetaNavyImage,
        setMetaRedImage,
        setMetaTealImage,
      }}
    >
      <div
        style={{
          backgroundImage: `url(${background1})`,
          margin: 0,
          minHeight: "100%",
          backgroundSize: "contain",
        }}
      >
        <Header></Header>
        <div ref={errorRef}>
          {error && <div className="error">{error}</div>}
        </div>
        {(currentPage === "pledges" ||
          currentPage === undefined ||
          currentPage === null) && <LandingPage />}
        {currentPage === "output" && <Output />}
        <Footer></Footer>
      </div>
    </AppContext.Provider>
  );
}

export default App;
